import * as PaymentMethodsActionTypes from '../actionTypes/PaymentMethodsActionTypes';

export const updatePaymentMethod = (params, isXStandardizationRequired) => ({
    type: PaymentMethodsActionTypes.UPDATE_PAYMENT_METHOD,
    payload: {
        ...params,
        customHeaders: { 'X-STANDARDIZATION-REQUIRED': isXStandardizationRequired },
    },
});

export const addPaymentMethod = (params, userAction, isXStandardizationRequired) => ({
    type: PaymentMethodsActionTypes.ADD_PAYMENT_METHOD,
    payload: {
        ...params,
        customHeaders: { 'X-STANDARDIZATION-REQUIRED': isXStandardizationRequired },
    },
    userAction,
});

export const deletePaymentMethod = (params) => ({
    type: PaymentMethodsActionTypes.DELETE_PAYMENT_METHOD,
    payload: params,
});

export const cleanRequest = () => ({
    type: PaymentMethodsActionTypes.CLEAN_REQUEST_PAYMENT_METHOD,
});

export const hidePayment = () => ({
    type: PaymentMethodsActionTypes.HIDE_PAYMENT,
});

export const setDefaultPaymentMethod = (id) => ({
    type: PaymentMethodsActionTypes.SET_DEFAULT_PAYMENT_METHOD,
    payload: {
        id,
        requestBody: [
            { op: 'replace', path: '/expressCheckout', value: 'true' },
            { op: 'replace', path: '/isDefault', value: 'true' },
        ],
    },
});
